import TabViewState, { TabType } from './store/schema/TabViewState';

export default {
    TabViewAddTab: {
        name: 'TabViewAddTab',
        customData: (type: TabType, isShown: boolean, makeActive: boolean, data: any) => [
            type,
            isShown,
            makeActive,
        ],
    },
    TabViewCloseTab: {
        name: 'TabViewCloseTab',
        customData: (viewState: TabViewState, forceClose: boolean) => [
            viewState.type,
            viewState.isShown,
            viewState.isActive,
            forceClose,
            viewState.startTime ? new Date().getTime() - viewState.startTime : 0,
        ],
    },
    TabViewActivateTab: {
        name: 'TabViewActivateTab',
        customData: (viewState: TabViewState, isUserAction: boolean) => [
            viewState.type,
            isUserAction,
        ],
        options: {
            isVerbose: true,
        },
    },
};
